import { render, staticRenderFns } from "./PortraitPanel.vue?vue&type=template&id=708e5a16"
import script from "./PortraitPanel.vue?vue&type=script&lang=js"
export * from "./PortraitPanel.vue?vue&type=script&lang=js"
import style0 from "./PortraitPanel.vue?vue&type=style&index=0&id=708e5a16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports